// src/auth/jwt.ts
export interface JwtClaims {
  exp?: number; // seconds since epoch
  sub?: string;
  orgId?: string;
  email?: string;
  given_name?: string;
  family_name?: string;
  zoneinfo?: string;
  [key: string]: unknown;
}

function base64UrlDecode(input: string): string {
  const pad = input.length % 4 === 0 ? '' : '='.repeat(4 - (input.length % 4));
  const b64 = (input + pad).replace(/-/g, '+').replace(/_/g, '/');
  // atob yields a Latin-1 byte string; re-decode as UTF-8 so non-ASCII claim
  // values (e.g. Arabic provider names) survive. atob+TextDecoder, not bare atob.
  const bytes = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

export function decodeJwt(token: string | null | undefined): JwtClaims | null {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    return JSON.parse(base64UrlDecode(parts[1])) as JwtClaims;
  } catch {
    return null;
  }
}

/** True if the token is missing, unparseable, or expires within `marginSec`. */
export function isExpired(token: string | null | undefined, marginSec = 30): boolean {
  const claims = decodeJwt(token);
  if (!claims?.exp) return true;
  const nowSec = Date.now() / 1000;
  return claims.exp - marginSec <= nowSec;
}
